/* eslint-disable jsx-a11y/anchor-has-content */
import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import { useState } from 'react';

import { navItemType } from '~/constants/nav-footer-v2';
import { type MobileBottomNavItem } from '~/interfaces/HeaderFooterNavV2';
import { useLayoutStore } from '~/providers/layout-store-provider';

import AllSportsButton from './components/AllSportsButton';
import AllSportsMenu from './components/AllSportsMenu';
import BetslipToggle from './components/BetslipToggle';
import NavLink from './components/NavLink';
import styles from './MobileBottomNav.module.css';

export const MobileBottomNav = () => {
  const repub = useLayoutStore((s) => s.repub);
  const mobileBottomNavData = useLayoutStore((s) => s.navData.mobileBottomNav);
  const [allSportsOpen, setAllSportsOpen] = useState(false);

  return (
    <nav
      aria-label="Mobile Bottom Navigation Bar"
      className={`${styles.mobileBottomNavContainer}`}
      data-testid="mobile-bottom-nav-v2">

			<ul
        className={`${styles.bottomNavigation} ${allSportsOpen ? styles.open : ''}`}>

				{mobileBottomNavData.map((item: MobileBottomNavItem) => {
          const isAllSports = item.type === navItemType.ALL_SPORTS_EXPANDABLE;

          return isAllSports ?
          <AllSportsButton
            allSportsOpen={allSportsOpen}
            key="AllSportsButton"
            setAllSportsOpen={setAllSportsOpen} /> :


          <NavLink item={item} key={item.name} />;

        })}
				<BetslipToggle repub={repub} />
			</ul>
			<AllSportsMenu
        allSportsOpen={allSportsOpen}
        setAllSportsOpen={setAllSportsOpen} />

			<div
        className={`${styles.backdrop} ${allSportsOpen ? '' : styles.off}`} />

		</nav>);

};